<template>
  <div class="home">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.region.create")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <AveineRegionForm :APIbaseURL="APIbaseURL" :region="region" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineRegionForm } from 'aveine-region';
import { Region } from 'aveine-toolbox';

export default {
  watch: {
  },
  data () {
    return {
      region: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineRegionForm
  },
  async created() {
    this.region = await Region.new()
    
    this.region.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
